export default __webpack_public_path__ + "static/IBMPlexSans-Italic-Latin2-3fb99cf388da08c31bd7a0b062d2d6e8.woff2";